import React, { useMemo } from 'react'
import './ShipmentCard.scss';
import moment from 'moment';
import { capitalizeFirstLetter } from '../../../helpers/utilities';
import { useNavigate } from 'react-router-dom';
import ProfilePicture from '../ProfilePicture/ProfilePicture';
import Icon from '../Icon';
import { GENRE_ICONS } from '../../constants/genres';
import { getProfilePublicPath } from '../../../helpers/profilePaths';


const ShipmentCard = ({ order,
    thumbnail,
    title,
    userName,
    creator,
    profilePic,
    category,
    tags,
    order_status,
    created_at,
    track

}) => {
    const navigate = useNavigate();
   
    const { order_id, } = order;
    const getCategoryIcon = useMemo(() => {
        const categoryLower = category?.toLowerCase();
        return GENRE_ICONS[categoryLower] || 'creations';
    }, [category]);
    const handleViewDetails = () => {
        navigate(`/shipments/${order_id}`);
    }


    return (
        <div className='shipment-card'>
            <div className='shipment-body'>
                <div className='d-flex aic'>
                    <ProfilePicture imgUrl={profilePic} no_edit={true} showIcon={false} width={32} height={32} handleClick={() => {
                        const p = getProfilePublicPath(creator);
                        if (p) navigate(p);
                    }} />
                    <p className='fs-regular fg-dark fw-bold my-0 ml-8 tt-uppercase'>{userName}</p>
                </div>
                <div className='shipment-image pt-16'>
                    <img src={thumbnail} alt={title} />
                </div>

                <div className="mt-12">
                    <div className='d-flex aic'>
                        <Icon
                            alias={getCategoryIcon}
                            className={'category-icon'}
                            height={32}
                            width={32}
                        />
                        <div className='ml-8'>
                            <p className='fs-regular fg-dark fw-bold'>{title}</p>
                            {tags?.length > 0 && <span className="cultural-area">{tags[0]}</span>}
                        </div>
                        <div className='d-flex f-row w-100 aie jce'>
                            <span className='fg-dark fs-regular fw-medium d-flex f-row' >{order.subtotal?`${order.subtotal}€`:""}</span>
                        </div>
                    </div>

                </div>
                <div className='shipment-status'>
                    <div className={`status `}>
                        <span className={`dot ${order_status?.toLowerCase()}`}></span>
                        {capitalizeFirstLetter(order_status)}
                        <span className={"dot-time"}></span>

                        <span className='fg-dark'>{
                            new Date(created_at).toLocaleString("fr-FR", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                            })}</span>


                    </div>

                    {track && <button
                        className="btn red-outline-btn d-flex aic jcc ml-auto fs-tiny px-24 px-4 btn-xs"
                        onClick={() => handleViewDetails(order_id)}>
                        Track
                    </button>}

                </div>
            </div>
        </div>
    )
}

export default ShipmentCard;    